export default {"src":"/_next/static/media/usa.2e7b4817.svg","height":17,"width":26,"blurWidth":0,"blurHeight":0};